// extracted by mini-css-extract-plugin
module.exports = {"client":"styles_client__1yJVl","icon":"styles_icon__3siVy","data":"styles_data__3S3eE","title":"styles_title__1XkR3","type":"styles_type__1Lf41"};